import {
  i18n
} from "./../../plugins/vue-i18n";

export default class Frequency {
  constructor(name, monthsCount) {
    this.name = name;
    this.value = name;
    this.text = i18n.t("CONTENT." + name);
    this.monthsCount = monthsCount; // can be null
  }

  static createFromData(data) {
    return new Frequency(
      data.name,
      data.monthsCount
    );
  }
}
